<template v-resize="onResize">
  <v-card class="elevation-0">
    <v-card-text v-if="isMobile">               
      <v-row>
        <v-select v-model="modelAxleTypeId" dense
          :items="viItem.axles" item-text="axleTypeName" item-value="axleTypeId"
          @change="modelAxleTypeIdChanged" :clearable="false" :menu-props="menuProps"
          stack-label outlined class="mr-4" attach >
          <!-- <template v-slot:item="menuProps">
            {{menuProps.item.axleTypeName}}
          </template> -->
        <template v-slot:selection="{ item }">
            <span class="text-wrap">{{ item.axleTypeName }}</span>
          </template>
        <template v-slot:item="{item}">
            <span class="text-wrap">{{ item.axleTypeName }}</span>
        </template>
        </v-select>
      </v-row>
      <v-row>
        <!-- <v-cols cols="4" xl="4" lg="4" md="4" sm="4"> -->
          <wrs-v-number v-model="viItem.legal"
            stack-label outlined dense disabled format="int"
            :label="viItem.legalLabel"
            :class="getIsOver.legal ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'"/>

            <wrs-v-number v-model="viItem.restricted" v-if="viItem.isRestricted"
            stack-label outlined dense disabled format="int"
            :class="getIsOver.restricted ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'"/>

            <wrs-v-number v-model="modelActualWeight" @input="emitInputEvent"
            format="int" :errors="validationErrors"
            stack-label outlined dense :disabled="modelAxleTypeId==null"
            :label="viItem.actualLabel"
            :class="getIsOver.any ? 'wrsInputHigh mr-4' : 'mr-4'"/>
        <!-- </v-cols> -->
      </v-row>
    </v-card-text>
    <v-card-text v-if="!isMobile">          
      <v-row>
        <!-- <v-cols cols="6" xl="6" lg="6" md="6" sm="6"> -->
          <div class="select-container pa-0">
            <v-select v-model="modelAxleTypeId" dense
              :items="viItem.axles" item-text="axleTypeName" item-value="axleTypeId"
              @change="modelAxleTypeIdChanged" :clearable="false" :menu-props="menuProps"
              stack-label outlined class="mr-4" attach>
            </v-select>
          </div>
        <!-- </v-cols> -->
        <!-- <v-cols cols="2" xl="2" lg="2" md="2" sm="2"> -->
          <div>
            <wrs-v-number v-model="viItem.legal"
              stack-label outlined dense disabled format="int"
              :class="getIsOver.legal ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'"/>
          </div>
        <!-- </v-cols>
        <v-cols cols="2" xl="2" lg="2" md="2" sm="2"> -->
          <div v-if="hasAnyRestricted || viItem.isRestricted">
            <wrs-v-number v-model="viItem.restricted" v-if="viItem.isRestricted"
            stack-label outlined dense disabled format="int"
            :class="getIsOver.restricted ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'"/>
          </div>
        <!-- </v-cols>
        <v-cols cols="2" xl="2" lg="2" md="2" sm="2"> -->
          <div>
            <wrs-v-number v-model="modelActualWeight" @input="emitInputEvent"
            format="int" :errors="validationErrors"
            stack-label outlined dense :disabled="modelAxleTypeId==null"
            :class="getIsOver.any ? 'wrsInputHigh mr-4' : 'mr-4'"/>
          </div>
        <!-- </v-cols> -->
      </v-row>          
    </v-card-text>
  </v-card>
</template>

<script>

  import WrsVuetifyNumber from '../../WrsVuetifyNumber.vue';
  //import WrsViSelectBig from '../WrsViSelectBig.vue';

  export default {
    components: {
      'wrs-v-number': WrsVuetifyNumber,
      //'wrs-vi-select-big': WrsViSelectBig,
    },
    data() {
      return {
        isMobile: false
      }
    },
    props: {
      viItem: {
        type: Object,
        default: function () {
          return {
            actualLabel: "",
            axles: [],
            value: 0,
            isOverLegal: false,
            isOverRestricted: false,
            isRestricted: false,
            orderNumber: 0,
            axlePositionId: 0,
            axleTypeId: 0,
            legal: 0,
            restricted: 0,
            isRestrictionReduced: false,
            requiredError: "",
            label: "",
            isRequired: true,
            error: "",
            hasError: false
          };
        },
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      hasAnyRestricted: {
        type: Boolean,
        default: false
      },
    },
    mounted(){
      this.onResize();
    },
    computed: {
      modelAxleTypeId: {
        get() {
          return this.viItem.axleTypeId;
        },
        set(value) {
          this.viItem.axleTypeId = value;
        }
      },
      modelActualWeight: {
        get() {
          return this.viItem.value;
        },
        set(value) {
          this.viItem.value = value;
        }
      },
      validationErrors() {
        const errors = [];

        this.checkForErrors(this.viItem);
        if (this.viItem.hasError) errors.push(this.viItem.error);

        return errors;
      },
      getIsOver: function () {
        let res = {
          legal: false,
          restricted: false,
          any: false
        };
        if (!this.viItem.hasError) {
          res.legal = this.viItem.isOverLegal;
          res.restricted = this.viItem.isOverRestricted;
          res.any = this.viItem.isOverLegal || this.viItem.isOverRestricted;
        }

        return res;
      },
      axleName: {
        get() {
          let item = this.viItem.axles.find(element => element.axleTypeId == this.viItem.axleTypeId);
          if (item) {
            return item.axleTypeName;
          }
          else {
            return "";
          }
        }
      },
      menuProps: {
        get() {
          return {
            top: this.viItem.orderNumber > 2? true: false,
            offsetY: true,
            maxHeight: 180
          };
        }
      },
    },
    methods: {
      checkForErrors: (vi) => {
        vi.isOverLegal = false;
        vi.isOverRestricted = false;

        vi.hasError = false;
        vi.error = "";

        var required = vi.isRequired;
        if (vi.axleTypeId != null && vi.axleTypeId > 0) required = true;

        if (required && (isNaN(vi.value) || vi.value <= 0)) {
          vi.hasError = true;
          vi.error = vi.requiredError;
          return;
        }

        if (!vi.hasError) {
          if (vi.isRestricted) {
            if (parseInt(vi.value) > parseInt(vi.restricted)) {
              vi.isOverRestricted = true;
              vi.hasError = true;
              vi.error = vi.restrictedError;
              return;
            }
          }
        }

        if (!vi.hasError) {
          if (vi.isFaop) {
            if (vi.value > vi.faop) {
              vi.isOverLegal = true;
            }
          }
          else {
            if (vi.value > vi.legal) {
              vi.isOverLegal = true;
            }
          }
        }
      },
      modelAxleTypeIdChanged: function () {
        if (this.viItem.axleTypeId == null || this.viItem.axleTypeId <= 0) {
          this.viItem.legal = 0;
          this.viItem.value = 0;
          this.viItem.isRestricted = false;
          this.viItem.restricted = null;
        }
        else {
          let selectedAxleType = this.viItem.axles.find(element => element.axleTypeId == this.viItem.axleTypeId);
          if (selectedAxleType) {
            this.viItem.legal = selectedAxleType.legalWeight;
            if (selectedAxleType.isRestrictionReduced && this.viItem.restrictionPercent > 0) {
              this.viItem.isRestricted = true;
              this.viItem.restricted = parseInt(selectedAxleType.legalWeight * this.viItem.restrictionPercent / 100);
            }
            else {
              this.viItem.isRestricted = false;
              this.viItem.restricted = null;
            }
          }
        }

        this.$emit('input');
      },
      emitInputEvent: function () {
        this.$emit('input');
      },
      onResize: function () {
        if (window.innerWidth < 769)
          this.isMobile = true;
        else
          this.isMobile = false;
      }
    }
  }
</script>
